import React from 'react';
import { Button } from '@cimpress/react-components';

type RecomputePlacementProps = {
    disabled?: boolean;
    disabledReason?: string;
    onClick: () => void;
};

/**
 * "Recompute Placement" button for documents in `GARMENT_WARP` mode.
 * Auto-placement is recalculated only upon explicit user trigger to avoid unexpectedly
 * overriding manual adjustments. Disabled (with an explanatory tooltip) when any required
 * input is missing.
 */
const RecomputePlacement: React.FC<RecomputePlacementProps> = ({ disabled, disabledReason, onClick }) => (
    <div className='garment-recompute-placement'>
        <span title={disabled ? disabledReason : undefined}>
            <Button disabled={disabled} onClick={onClick}>
                Recompute Placement
            </Button>
        </span>
    </div>
);

export default RecomputePlacement;
